export default {
  items: [
    {
      name: "Dashboard",
      url: "/dashboard",
      icon: "icon-speedometer",
    },

    {
      name: "Licensee",
      url: "/licensee",
      icon: "cui-bookmark",
    },

    {
      name: "Patients",
      url: "/patientusers",
      icon: "fa fa-users fa-lg",
      children: [
        {
          name: "Profiles",
          url: "/patientusers/patientsprofile",
          icon: "fa fa-file-image-o",
        },
        {
          name: "Patient Orders",
          url: "/patientusers/patientorder",
          icon: "nav-icon nav-icon fa fa-circle-o-notch",
        },
        {
          name: "Patient Invoices",
          url: "/patientusers/patientInvoice",
          icon: "fa fa-credit-card custom",
        },
        {
          name: "Patient Payments",
          url: "/patientusers/patientPayment",
          icon: "nav-icon fa fa-cc-mastercard",
        },
      ],
    },
    {
      name: "Chemists",
      url: "/chemistuser",
      icon: "fa fa-users fa-lg",
      children: [
        {
          name: "Profiles",
          url: "/chemistuser/chemistprofile",
          icon: "fa fa-file-image-o",
        },
        {
          name: "Chemist Orders",
          url: "/chemistuser/chemistorders",
          icon: "nav-icon nav-icon fa fa-circle-o-notch",
        },
        {
          name: "Chemist Invoices",
          url: "/chemistuser/chemistInvoice",
          icon: "fa fa-credit-card custom",
        },
        {
          name: "Chemist Payments",
          url: "/chemistuser/chemistPayment",
          icon: "nav-icon fa fa-cc-mastercard",
        },
      ],
    },
    {
      name: "Item Master",
      url: "/itemmaster",
      icon: "fa fa-users fa-lg",
    },
    {
      name: "Product Returns",
      url: "/productreturns",
      icon: "cui-action-undo",
    },
    {
      name: "Credit Notes",
      url: "/creditnotes",
      icon: "cui-calculator ",
    },
    {
      name: "Platform Earnings",
      url: "/platformearnings",
      icon: "nav-icon fa fa-credit-card ",
    },
    {
      name: "Reported Issues",
      url: "/reportedIssues",
      icon: "nav-icon icon-question",
    },

    // {
    //   name: "Feedback",
    //   url: "/feedback",
    //   icon: "icon-note"
    // },
    // {
    //   name: "Settings",
    //   url: "/settings",
    //   icon: "fa fa-wrench",
    //   children: [
    //     {
    //       name: "Unit",
    //       url: "/settings/unit",
    //       icon: "fa fa-barcode",
    //     },
    //     {
    //       name: "Countries",
    //       url: "/settings/country",
    //       icon: "icon-location-pin",
    //     },
    //     {
    //       name: "Currencies",
    //       url: "/settings/currency",
    //       icon: "fa fa-money",
    //     },
    //     {
    //       name: "Country Currency",
    //       url: "/settings/countryCrncy",
    //       icon: "fa fa-gg-circle",
    //     },
    //     {
    //       name: "Payment Mode",
    //       url: "/settings/paymentmode",
    //       icon: "fa fa-credit-card",
    //     },
    //     {
    //       name: "Brand",
    //       url: "/settings/brand",
    //       icon: "fa fa-bitbucket",
    //     },
    //   ],
    // },
    {
      name: "App Version",
      url: "/appversion",
      icon: "fa fa-share-square-o",
    },
    {
      name: "Batch Admin",
      url: "/batchadmin",
      icon: "fa fa-lock",
    },
    // {
    //   name: 'Login',
    //   url: '/login',
    //   icon: 'icon-user',

    // },
  ],
};
